/*
  Groessentabelle (Drawer)

  1. Setzt die Ueberschrift des Drawers. Im Markup von
     sections/main-product.liquid steht noch "Größenguide"; die Datei ist zu
     gross, um sie ueber die API sicher zu bearbeiten, deshalb wird die
     Beschriftung hier korrigiert. In JS statt per CSS-Trick, damit die
     Ueberschrift nicht doppelt auftaucht, wenn eine Theme-Regel gewinnt.
  2. Hebt die Spalte hervor, die zur aktuell gewaehlten Groesse passt, und
     haelt sie beim Groessenwechsel aktuell.

  Den Link selbst rendert snippets/product-variant-picker.liquid an der
  richtigen Stelle. Weiter unten in dieser Datei sitzt zusaetzlich eine
  Korrektur, die die Beschriftung der Groessen-Auswahl nach jedem
  Neuaufbau wieder auf "Groesse: (Groessentabelle)" bringt.

  Funktioniert mit einer einfachen Kopfzeile (eine Spalte pro Groesse,
  z. B. XS S M L) und mit einer gruppierten Kopfzeile, in der eine
  Groesse per colspan mehrere Unterspalten umfasst - die Beschriftungszeile
  ist immer die ERSTE Zeile im <thead> (bzw. die erste Zeile der Tabelle,
  wenn es kein <thead> gibt).
*/
(() => {
  const SIZE_RE = /size|gr(ö|oe|o)(ß|ss)e/i;
  const DRAWER_TITLE = 'Größentabelle';

  function normalize(value) {
    return (value || '').trim().toUpperCase();
  }

  function fixTitles() {
    document.querySelectorAll('.size-guide-drawer__title').forEach((el) => {
      if (el.textContent.trim() !== DRAWER_TITLE) el.textContent = DRAWER_TITLE;
    });
    document.querySelectorAll('.size-guide-drawer [role="dialog"]').forEach((el) => {
      el.setAttribute('aria-label', DRAWER_TITLE);
    });
  }

  // Expands the label header row into a flat array, one entry per data
  // column (colspan > 1 repeats the same label across its columns).
  function buildColumnLabels(labelRow) {
    const labels = [];
    Array.from(labelRow.children).forEach((cell, index) => {
      if (index === 0) return; // first cell is the row/section label, not a size
      const span = parseInt(cell.getAttribute('colspan'), 10) || 1;
      for (let i = 0; i < span; i += 1) {
        labels.push(normalize(cell.textContent));
      }
    });
    return labels;
  }

  function highlightColumn(table, sizeLabel) {
    const labelRow = table.querySelector('thead tr') || table.querySelector('tr');
    if (!labelRow) return;

    const columnLabels = buildColumnLabels(labelRow);
    const target = normalize(sizeLabel);

    table.querySelectorAll('tr').forEach((row) => {
      Array.from(row.children).forEach((cell, index) => {
        if (index === 0) return;
        const columnIndex = index - 1;
        const isMatch = !!target && columnLabels[columnIndex] === target;
        cell.classList.toggle('size-guide-col--active', isMatch);
      });
    });
  }

  // Die Groessen-Option heisst je nach Produkt "Größe", "Grösse" oder "Size".
  function isSizeInput(el) {
    return !!el && el.type === 'radio' && SIZE_RE.test(el.name || '');
  }

  function currentSizeValue() {
    const checked = document.querySelectorAll(
      '.product__info-container input[type="radio"]:checked'
    );
    for (const el of checked) {
      if (isSizeInput(el)) return el.value;
    }
    return null;
  }

  function initTables() {
    fixTitles();
    const tables = document.querySelectorAll('.size-guide-drawer__body table');
    if (!tables.length) return;
    tables.forEach((table) => highlightColumn(table, currentSizeValue()));
  }

  document.addEventListener('DOMContentLoaded', initTables);

  // React live to size changes, whether the drawer is already open or not.
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (!isSizeInput(event.target)) return;
    document
      .querySelectorAll('.size-guide-drawer__body table')
      .forEach((table) => highlightColumn(table, event.target.value));
  });

  // Safety net: sections can be re-rendered by the theme (variant changes,
  // quick add). Re-apply the heading whenever the drawer is opened.
  document.addEventListener('click', (event) => {
    if (event.target.closest && event.target.closest('.product-popup-modal__button')) {
      setTimeout(fixTitles, 0);
    }
  });
})();


/* ------------------------------------------------------------------
   Beschriftung der Groessen-Auswahl geradebiegen.

   Egal welches Markup gerade ankommt (frische Seite, Neuaufbau nach
   Variantenwechsel, alte gecachte Fassung): am Ende steht dort immer
   genau

       Groesse: (Groessentabelle)

   - kein Buchstabe der gewaehlten Groesse dahinter (den zeigen die
     Buttons darunter),
   - genau ein Link, in Klammern,
   - immer mit der Beschriftung "Groessentabelle".

   Ein zweiter Link, der von irgendwoher dazukommt, wird entfernt.
   ------------------------------------------------------------------ */
(() => {
  const SIZE_RE = /size|gr(ö|oe|o)(ß|ss)e/i;
  const LINK_TEXT = 'Größentabelle';
  let scheduled = false;

  function isSizeLegend(legend) {
    const option = legend.getAttribute('data-option') || '';
    const head = (legend.textContent || '').split(':')[0];
    return SIZE_RE.test(option) || SIZE_RE.test(head);
  }

  function legendName(legend) {
    const option = (legend.getAttribute('data-option') || '').trim();
    if (option) return option;
    return ((legend.textContent || '').split(':')[0] || '').trim();
  }

  function normalizeSizeLabels() {
    document.querySelectorAll('.product-form__input--pill legend.form__label').forEach((legend) => {
      if (!isSizeLegend(legend)) return;

      const name = legendName(legend);
      if (!name) return;

      // Vorhandenen Oeffner suchen: erst in der Beschriftung, sonst im
      // alten (ausgeblendeten) Sizeguide-Kasten.
      let opener =
        legend.querySelector('modal-opener.product-popup-modal__opener') ||
        document.querySelector('.size-guide modal-opener.product-popup-modal__opener');

      const expected = opener ? `${name}: (${LINK_TEXT})` : `${name}:`;
      const current = (legend.textContent || '').replace(/\s+/g, ' ').trim();
      if (current === expected) return;

      // Ueberzaehlige Oeffner in der Beschriftung wegwerfen.
      legend.querySelectorAll('modal-opener.product-popup-modal__opener').forEach((el) => {
        if (el !== opener) el.remove();
      });

      if (opener) {
        opener.remove(); // aushaengen, Referenz bleibt bestehen
        const button = opener.querySelector('.product-popup-modal__button');
        if (button && button.textContent.trim() !== LINK_TEXT) button.textContent = LINK_TEXT;
      }

      legend.textContent = '';
      legend.appendChild(document.createTextNode(`${name}:`));

      if (opener) {
        const wrap = document.createElement('span');
        wrap.className = 'size-guide-inline';
        wrap.appendChild(document.createTextNode('('));
        wrap.appendChild(opener);
        wrap.appendChild(document.createTextNode(')'));
        legend.appendChild(document.createTextNode(' '));
        legend.appendChild(wrap);
      }
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      normalizeSizeLabels();
    });
  }

  document.addEventListener('DOMContentLoaded', schedule);
  if (document.readyState !== 'loading') schedule();

  // Section-Rerender (Variantenwechsel, Quick-Add) abfangen.
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

/* ------------------------------------------------------------------
   Wischgesten zum Schliessen (Touch-Geraete)

   Betrifft die drei Flaechen, die sich auf der Produktseite ueber den
   Inhalt legen:

     1. Groessentabelle  -> modal-dialog.size-guide-drawer   (Schublade)
     2. Versand          -> .gnvi__ov > .gnvi__panel         (Schublade)
     3. Kostentransparenz-> .gnkt__ov > .gnkt__sheet         (Blatt von
        unten am Handy, Schublade von rechts ab 750 px)

   Gesten:
     - Schubladen: waagerecht wischen, in beide Richtungen. Nach rechts
       laeuft die Flaeche mit dem Finger mit (sie kommt ja von rechts),
       nach links zaehlt nur der Weg.
     - Blatt von unten: nach unten wischen, das Blatt laeuft mit.

   Geschlossen wird immer ueber den vorhandenen Schliessen-Knopf der
   jeweiligen Flaeche, damit deren eigenes Aufraeumen (Scroll-Sperre,
   Fokus, Zeitschaltung) genauso ablaeuft wie beim Antippen.

   Zurueckhaltung an zwei Stellen, damit nichts kaputtgeht:
     - Beginnt der Finger in etwas, das selbst waagerecht rollt (die
       Groessentabelle ist breiter als das Handy), bleibt die Geste aus.
     - Nach unten wird nur geschlossen, wenn der Inhalt schon ganz oben
       steht - sonst wuerde jedes Hochscrollen die Flaeche zuklappen.
   ------------------------------------------------------------------ */
(() => {
  if (typeof window === 'undefined' || !('ontouchstart' in window)) return;

  const DISTANCE = 60; // Mindestweg in px
  const RATIO = 1.4; // Wie eindeutig die Richtung sein muss
  const MAX_MS = 800; // Laenger gewischt gilt als Scrollen, nicht als Geste

  // Beschreibt die drei Flaechen: Wo faengt die Geste an, welches Stueck
  // bewegt sich, und wie wird geschlossen.
  const TARGETS = [
    {
      panel: '.size-guide-drawer__panel',
      isOpen: (panel) => {
        const host = panel.closest('modal-dialog');
        return !!host && host.hasAttribute('open');
      },
      axis: () => 'x',
      close: (panel) => {
        const host = panel.closest('modal-dialog');
        const button = host && host.querySelector('[id^="ModalClose-"]');
        if (button) button.click();
      },
    },
    {
      panel: '.gnvi__panel',
      isOpen: (panel) => {
        const ov = panel.closest('.gnvi__ov');
        return !!ov && ov.classList.contains('is-open');
      },
      axis: () => 'x',
      close: (panel) => {
        const ov = panel.closest('.gnvi__ov');
        const button = ov && ov.querySelector('[data-gnvi-close]');
        if (button) button.click();
      },
    },
    {
      panel: '.gnkt__sheet',
      isOpen: (panel) => {
        const ov = panel.closest('.gnkt__ov');
        return !!ov && ov.classList.contains('is-open');
      },
      // Am Handy kommt das Blatt von unten, ab 750 px von rechts.
      axis: () => (window.matchMedia('(min-width: 750px)').matches ? 'x' : 'y'),
      close: (panel) => {
        const ov = panel.closest('.gnkt__ov');
        const button = ov && ov.querySelector('[data-gnkt-close]');
        if (button) button.click();
      },
    },
  ];

  // Rollt eines der Elemente zwischen Startpunkt und Flaeche selbst in
  // die Richtung, in die gewischt wird? Dann gehoert die Bewegung dorthin.
  function scrollsAlong(start, panel, axis) {
    let node = start;
    while (node && node !== panel && node.nodeType === 1) {
      if (axis === 'x' && node.scrollWidth > node.clientWidth + 2) return true;
      if (axis === 'y' && node.scrollTop > 2) return true;
      node = node.parentElement;
    }
    if (axis === 'y') {
      const scroller = panel.querySelector('.gnkt__scroll');
      if (scroller && scroller.scrollTop > 2) return true;
    }
    return false;
  }

  let active = null;

  function release(panel, animate) {
    panel.style.transition = animate ? '' : 'none';
    panel.style.transform = '';
    if (!animate) {
      // Im naechsten Bild die Uebergangs-Sperre wieder abnehmen.
      requestAnimationFrame(() => {
        panel.style.transition = '';
      });
    }
  }

  document.addEventListener(
    'touchstart',
    (event) => {
      active = null;
      if (!event.touches || event.touches.length !== 1) return;
      const target = event.target;
      if (!target || !target.closest) return;

      for (const entry of TARGETS) {
        const panel = target.closest(entry.panel);
        if (!panel || !entry.isOpen(panel)) continue;

        const axis = entry.axis();
        if (scrollsAlong(target, panel, axis)) return;

        const touch = event.touches[0];
        active = {
          entry,
          panel,
          axis,
          x: touch.clientX,
          y: touch.clientY,
          time: Date.now(),
          moved: false,
        };
        return;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!active || !event.touches || event.touches.length !== 1) return;
      const touch = event.touches[0];
      const dx = touch.clientX - active.x;
      const dy = touch.clientY - active.y;

      // Laeuft die Bewegung quer zur Geste, ist es Scrollen - abbrechen.
      if (active.axis === 'x' && Math.abs(dy) > Math.abs(dx) * RATIO) {
        if (active.moved) release(active.panel, false);
        active = null;
        return;
      }
      if (active.axis === 'y' && Math.abs(dx) > Math.abs(dy) * RATIO) {
        if (active.moved) release(active.panel, false);
        active = null;
        return;
      }

      // Mitlaufen nur in die Richtung, in die die Flaeche ohnehin geht.
      const follow = active.axis === 'x' ? Math.max(0, dx) : Math.max(0, dy);
      if (follow > 4) {
        active.moved = true;
        active.panel.style.transition = 'none';
        active.panel.style.transform =
          active.axis === 'x' ? `translateX(${follow}px)` : `translateY(${follow}px)`;
      } else if (active.moved) {
        active.panel.style.transform = '';
      }
    },
    { passive: true }
  );

  function finish(event) {
    if (!active) return;
    const current = active;
    active = null;

    const touch = event.changedTouches && event.changedTouches[0];
    if (!touch) {
      if (current.moved) release(current.panel, false);
      return;
    }

    const dx = touch.clientX - current.x;
    const dy = touch.clientY - current.y;
    const quick = Date.now() - current.time <= MAX_MS;

    let hit = false;
    if (current.axis === 'x') {
      hit = quick && Math.abs(dx) >= DISTANCE && Math.abs(dx) > Math.abs(dy) * RATIO;
    } else {
      hit = quick && dy >= DISTANCE && dy > Math.abs(dx) * RATIO;
    }

    if (hit) {
      // Die Flaeche faehrt mit ihrer eigenen Bewegung hinaus; die
      // Handspur vorher abnehmen, sonst bliebe sie stehen.
      release(current.panel, true);
      current.entry.close(current.panel);
      return;
    }

    if (current.moved) release(current.panel, true);
  }

  document.addEventListener('touchend', finish, { passive: true });
  document.addEventListener('touchcancel', finish, { passive: true });
})();
